import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadButton } from '@/components/buttons';
import { DocumentSection } from '@/sections/documents/DocumentSection';
import { Link } from '@/components/links';
import { CONTACT_EMAIL_DPO } from '@/constants/contacts';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
import { useRouter } from 'next/router';
import { FILES } from '@/constants/files';
export function InformationMemorandum() {
  const $ = _c(51);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["personalData"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const isCsLanguage = useIsSelectedLanguage("cs");
  const isHuLanguage = useIsSelectedLanguage("hu");
  const {
    locale
  } = useRouter();
  let t1;
  if ($[1] !== isCsLanguage || $[2] !== isHuLanguage || $[3] !== locale || $[4] !== t) {
    t1 = isCsLanguage ? [{
      path: FILES(locale).informationMemorandum,
      title: t("categories.1.documents.informationMemorandum"),
      id: "informationMemorandum"
    }, {
      path: FILES(locale).informationMemorandumPartners,
      title: t("categories.1.documents.informationMemorandumPartners"),
      id: "informationMemorandumPartners"
    }, {
      path: FILES(locale).informationMemorandumSID,
      title: t("categories.1.documents.SID"),
      id: "SID"
    }, {
      path: FILES(locale).informationMemorandumNRKI,
      title: t("categories.1.documents.NRKI"),
      id: "NRKI"
    }, {
      path: FILES(locale).personalDataProtection,
      title: t("categories.1.documents.CRIF"),
      id: "CRIF"
    }, {
      path: FILES(locale).NRKIInformationMemorandum,
      title: t("categories.1.documents.goodStanding"),
      id: "goodStanding"
    }] : isHuLanguage ? [{
      path: FILES(locale).informationMemorandum,
      title: t("categories.1.documents.informationMemorandum"),
      id: "informationMemorandum"
    }, {
      path: FILES(locale).informationMemorandumPartners,
      title: t("categories.1.documents.informationMemorandumPartners"),
      id: "informationMemorandumPartners"
    }] : [{
      path: FILES(locale).informationMemorandum,
      title: t("categories.1.documents.informationMemorandum"),
      id: "informationMemorandum"
    }, {
      path: FILES(locale).informationMemorandumPartners,
      title: t("categories.1.documents.informationMemorandumPartners"),
      id: "informationMemorandumPartners"
    }, {
      path: FILES(locale).personalDataProtection,
      title: t("categories.1.documents.CRIF"),
      id: "CRIF"
    }];
    $[1] = isCsLanguage;
    $[2] = isHuLanguage;
    $[3] = locale;
    $[4] = t;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const documents = t1;
  let t2;
  if ($[6] !== t) {
    t2 = t("categories.1.title");
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t) {
    t3 = t("categories.1.text");
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <p className="mb-8">{t3}</p>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t) {
    t5 = t("categories.1.subtitle");
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = <h3 className="mb-6 text-base font-bold lg:text-2xl">{t5}</h3>;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t) {
    t7 = t("categories.1.list.1");
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t7) {
    t8 = <li>{t7}</li>;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t) {
    t9 = t("categories.1.list.2");
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t9) {
    t10 = <li>{t9}</li>;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t) {
    t11 = t("categories.1.list.3");
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11) {
    t12 = <li>{t11}</li>;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t) {
    t13 = t("categories.1.list.4");
    $[28] = t;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Link to={`mailto:${CONTACT_EMAIL_DPO}`} testId="contactDpo" analyticsParam="contactDpo">{CONTACT_EMAIL_DPO}</Link>;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t13) {
    t15 = <li>{t13}{" "}{t14}.</li>;
    $[31] = t13;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t10 || $[34] !== t12 || $[35] !== t15 || $[36] !== t8) {
    t16 = <ul className="mb-8 list-disc space-y-3 pl-5 marker:text-blue-500">{t8}{t10}{t12}{t15}</ul>;
    $[33] = t10;
    $[34] = t12;
    $[35] = t15;
    $[36] = t8;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t) {
    t17 = t("categories.1.documents.title");
    $[38] = t;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t17) {
    t18 = <h3 className="mb-6 text-base font-bold lg:text-2xl">{t17}</h3>;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== documents) {
    t19 = <div className="inline-block">{documents.map(_temp)}</div>;
    $[42] = documents;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t16 || $[45] !== t18 || $[46] !== t19 || $[47] !== t2 || $[48] !== t4 || $[49] !== t6) {
    t20 = <DocumentSection title={t2} isDropdown={false} id="informationMemorandum">{t4}{t6}{t16}{t18}{t19}</DocumentSection>;
    $[44] = t16;
    $[45] = t18;
    $[46] = t19;
    $[47] = t2;
    $[48] = t4;
    $[49] = t6;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  return t20;
}
function _temp(t0) {
  const {
    path,
    title,
    id
  } = t0;
  return <div className="mb-2 lg:mb-4" key={id}><DownloadButton to={path} testId={id} analyticsParam={id} className="sm:w-full">{title}</DownloadButton></div>;
}